import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { PitchCardComponent } from '@App/modules/pitch-card-shared/components/pitch-card/pitch-card.component';
import { SplitCamelCasePipe } from '@App/modules/pitch-card-shared/pipes';
import { UserCommonApiService } from '@App/common/services';
import { PitchCardModalsWrapperService } from '@App/modules/pitch-card-shared/services';
import { CardPackageService } from '@App/modules/cards-packages/services';
import { StorageService } from '@Shared/services';
import { AuthService } from '@App/pages/auth/services';
import { AppSettings } from '@Shared/app.settings';
import { PitchCardTypeEnum } from '@App/common/enums';

@Component({
  selector: 'app-pitchcard-job-modals',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    DialogModule,
    CheckboxModule,
    ConfirmDialogModule,
    TranslateModule,
    PitchCardComponent,
    SplitCamelCasePipe
  ],
  templateUrl: './pitchcard-job-modals.component.html'
})
export class PitchCardJobModalsComponent extends PitchCardModalBase {
  @Input() showJobDetailsDialog: any;
  @Input() showJobRequirementsDialog: any;
  @Input() showApplyJobDialog: any;
  @Input() showApplyJobDialogByLink: any;
  @Input() currentPitchCard: any;
  @Input() benefits: any;
  @Input() workTypes: any;
  @Input() workTypesList: any;
  @Input() locationAddress: any;
  @Input() compensationDescription: any;
  @Input() isMobile: any;
  @Input() mobileMode: any;
  @Input() jobCardScaleFactor: any;
  @Input() scaleFactor: any;
  @Input() userResumeCard: any;
  @Input() validToApply: any;
  @Input() uniqueId: string;

  acceptPositionRequirements = false;
  userCommonService = inject(UserCommonApiService);
  private pitchCardModalsWrapperService = inject(PitchCardModalsWrapperService);
  private cardPackagesService = inject(CardPackageService);
  private storageService = inject(StorageService);
  private authService = inject(AuthService);
  private confirmationService = inject(ConfirmationService);
  private router = inject(Router);

  applyToTheJob() {
    this.userCommonService.addApplicant(this.currentPitchCard.id).subscribe({
      next: () => {
        this.onFlag('showApplyJobDialog', false);
        let message = `Your Resume PitchCard has been submitted to ${this.currentPitchCard.businessName}!`;

        if (this.userResumeCard.businessStatus != 2) {
          message = `Your Resume PitchCard is currently awaiting approval.  We will send it to ${this.currentPitchCard.businessName} as soon as it is approved.<br />
                (Less than 1 business day)`;
        }
        this.confirmationService.confirm({
          message,
          key: 'applyJobConfirmation',
          accept: () => {
            this.confirmationService.close();
          }
        });
      },
      error: (err) => {
        console.error(err.message);
      }
    });
  }

  goToCreateResume() {
    this.saveJobCardAliasLink(this.currentPitchCard);
    this.cardPackagesService.selectedType = PitchCardTypeEnum.Resume;
    this.router.navigate(['create']).then();
    this.storageService.setSession(AppSettings.DRAFT_BUSINESS_ID, null);
  }

  goToDraftResume(resumeId: any) {
    this.saveJobCardAliasLink(this.currentPitchCard);
    this.cardPackagesService.selectedType = PitchCardTypeEnum.Resume;
    this.storageService.setSession(AppSettings.DRAFT_BUSINESS_ID, resumeId);
    this.router.navigate(['create']).then();
  }

  handleAcceptPositionRequirements() {
    this.pitchCardModalsWrapperService.showApplyJobNowDialog.next(true);
    this.onFlag('showJobRequirementsDialog', false);
  }

  handlePitchCardTitleClick(event: any) {
    const { title, businessDetails } = event;

    this.pitchCardModalsWrapperService.setCurrentBusiness(businessDetails);
    this.pitchCardModalsWrapperService.onTitleClick(title);
  }

  hideRequirements() {
    this.onFlag('acceptPositionRequirements', false);
    this.onFlag('showJobRequirementsDialog', false);
  }

  openInNewTab(link: any) {
    this.pitchCardModalsWrapperService.openLinkInNewTab(link);
  }

  saveJobCardAliasLink({ alias }) {
    if (alias) {
      const shareLink = encodeURI(`/card/${alias}`);
      this.storageService.setSession(AppSettings.ALIAS_LINK, shareLink);
    }
  }

  signIn() {
    this.authService.setAction('SIGN_IN');
  }

  signUp() {
    this.authService.setAction('SIGN_UP');
  }

  validateLink(link: string) {
    if (link) {
      return (link && link.includes('https')) || (link && link.includes('http'))
        ? link
        : 'https://' + link;
    }
    return '#';
  }
}
